import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloudSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="cloud-simple" maskId="round-filled-radius-1-stroke-1.5-IconCloudSimple"><path d="M8.925 4C4.54081 4 1 7.58909 1 12C1 16.4109 4.54081 20 8.925 20H17.125C20.377 20 23 17.3383 23 14.0714C23 10.8045 20.377 8.14286 17.125 8.14286C16.852 8.14286 16.5829 8.1617 16.3191 8.19826C16.0807 8.23131 15.8574 8.11573 15.7595 7.94784C14.3846 5.58939 11.8407 4 8.925 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudSimple;
